import Vue from 'vue'
import axios from './axios'
import qiankunActive from '@/utils/qiankun-action'
import dataV from '@jiaminghi/data-view'
import router from './router.js';
import { website } from '@/config.js'
import draggable from 'avue-draggable'
import highlight from '@/page/components/highlight'
import { loadScript } from '@/utils/utils'
import App from './App.vue'
import ElementUI from 'element-ui';
import '@/icons/'
import './styles/common.scss'

import '@/utils/es6'
import hljs from 'highlight.js' //导入代码高亮文件
import 'highlight.js/styles/atom-one-dark.css'  //导入代码高亮样式

// import '@/mock/'
//导入主题文件
import '@/theme/index.js'
import 'element-ui/lib/theme-chalk/index.css';
console.log(process.env)
Vue.config.productionTip = false
window.axios = axios;
window.$loadScript = loadScript;
document.title = website.title
Vue.use(ElementUI);
Vue.use(window.AVUE);
Vue.use(draggable, {
  keys: 'O2BEeIv399qHQNhD6aGW8R8DEj4bqHXm'
})
Vue.component('avue-highlight', highlight)
Vue.prototype.$website = website;
const $loadingParams = {};
$loadingParams['element-loading-text'] = "加载中..."
$loadingParams['element-loading-background'] = "rgba(32,32,35, 0.8)"
Vue.prototype.$loadingParams = $loadingParams
Vue.use(dataV)
Vue.directive('highlight', function (el) {
  let highlight = el.querySelectorAll('pre code');
  highlight.forEach((block) => {
    hljs.highlightBlock(block)
  })
});


// 判断是否是qiankun环境，一定要写在最上面
if (window.__POWERED_BY_QIANKUN__) {
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__
}
let instance = null;
function render(props) {
  const { container } = props || {}
  instance = new Vue({
    router,
    render: h => h(App)
  }).$mount(container ? container.querySelector('#app') : '#app') // 用于限定当前上下文下的#app，防止与主应用中的#app冲突
}




//不是在qiankun环境下的话，独立运行
if (!window.__POWERED_BY_QIANKUN__) {
  var searchParams = new URLSearchParams(window.location.search);
  if(searchParams){
    const token =  searchParams.get('token');
    if (token) {
      localStorage.setItem('token', token)
      window.isFromCCRCWindow = true;
    }  
  }
   
  render()
}



export async function bootstrap(props) {
  console.log('erp-management bootstrap', props)
  if (props) {
    if (props.data.token) {
      localStorage.setItem('token', props.data.token)
    }
  }
}

export async function mount(props) {
  console.log('erp-management', props)
  qiankunActive.setActions({
    onGlobalStateChange: props.onGlobalStateChange,
    setGlobalState: props.setGlobalState
  })
  render(props);
}

export async function unmount(props) {
  console.log(props);
  console.log('erp-management unmount' , props)
  instance.$destroy() // 销毁子应用实例
}